<template>
    <div class="template-login-register step2">
        <header>
            <div class="container">
                <a href="https://www.simoniot.com/">
                    <img src="../../assets/img/logo-dark.png" alt="">
                </a>

                <router-link to='/login'>Login</router-link>
            </div>
        </header>

        <div class="content">
            <a href="https://www.simoniot.com/">
                <img width="250" src="../../assets/img/lightlogo.svg" alt="">
            </a>

            <h1>WELCOME TO SIMON IOT</h1>

            <h2>Your account has been created successfully</h2>

            <p>To activate your SIMON IOT account, please confirm your Registration by clicking the “Confirm Registration” link in the confirmation email that was sent to {{newAccountEmail}}</p>

            <p><strong>After your account is activated, you can login with your credentials at </strong> <a href="https://portal.simoniot.com">portal.simoniot.com</a></p>

            <p>Already Activated?</p>

            <router-link to='/login' class="btn">Login</router-link>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import VueSession from "vue-session";
import globalStore from "../../variables";
import { error } from "util";
import VueParticles from 'vue-particles'
import VueCookies from 'vue-cookies'

Vue.use(VueParticles)
Vue.use(VueSession);
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

export default {
    name: "RegisterStep2",
    data() {
        return {
            newAccountEmail: ''
        }
    },
    mounted: function() {
        var timestamp = new Date().getTime();
        this.newAccountEmail = window.newUserEmail
        window.newUserEmail = '';

        if (this.$cookies.get("token") || this.$session.get("token")) {
            this.$router.push("/dashboard");
        }
    }
};
</script>

<style lang="scss">

.template-login-register.step2 {
    position: relative;
    height: 100vh;
    background: rgba(0,255,151,1);
    background: -moz-linear-gradient(45deg, rgba(0,255,151,1) 0%, rgba(0,85,255,1) 100%);
    background: -webkit-gradient(left bottom, right top, color-stop(0%, rgba(0,255,151,1)), color-stop(100%, rgba(0,85,255,1)));
    background: -webkit-linear-gradient(45deg, rgba(0,255,151,1) 0%, rgba(0,85,255,1) 100%);
    background: -o-linear-gradient(45deg, rgba(0,255,151,1) 0%, rgba(0,85,255,1) 100%);
    background: -ms-linear-gradient(45deg, rgba(0,255,151,1) 0%, rgba(0,85,255,1) 100%);
    background: linear-gradient(45deg, rgba(0,255,151,1) 0%, rgba(0,85,255,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ff97', endColorstr='#0055ff', GradientType=1 );

    header {
        position: relative;
        background-color: #011826;
        padding: 18px 0;

        .container {
            display: flex;
            justify-content: space-between;
            align-content: center;
            align-items: center;

            a {
                color: #fff;
                font: 400 15px/16px "Roboto", "Arial", sans-serif;
            }
        }
    }

    .content {
        width: 1116px;
        max-width: 90vw;
        margin: auto;
        margin-top: 160px;
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 0 8px 15px rgba(0, 0, 0, .16);
        text-align: center;

        h1 {
            display: block;
            margin: 26px 0 17px;
            font: 700 47px/62px "Roboto", "Arial", sans-serif;
            color: #2F353A;
        }

        h2 {
            display: block;
            margin: 17px 0 28px;
            font: 700 20px/24px "Roboto", "Arial", sans-serif;
            color: #2F353A;
        }

        p {
            display: block;
            max-width: 750px;
            margin: auto;
            margin-top: 33px;
            margin-bottom: 33px;

            text-align: center;

            a {
                font-weight: 700;
            }
        }

        .btn {
            height: 35px;
            padding: 0 20px;

            background-color: #0088FF;
            border-radius: 5px;
            font: 400 14px/35px "Roboto", "Arial", sans-serif;
            color: #fff;
        }
    }
}
</style>
